<template>
  <div>
    <!--面包屑导航区域-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>硬件相关</el-breadcrumb-item>
      <el-breadcrumb-item>磁力锁问题列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--面包屑导航区域-->
    <!--卡片视图区-->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-select
              v-model="queryInfo.storeId"
              placeholder="请选择门店"
              @change="getList()"
              style="margin-left: 10px"
              clearable
              filterable
          >
            <el-option
                v-for="item in storelist"
                :key="item.id"
                :label="item.storename"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select  v-model="queryInfo.status" clearable  placeholder="请选择状态" @change="getList()"  style="margin-right:10px">
            <el-option label="未处理" value="0"></el-option>
            <el-option label="已处理" value="1"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <br>
      <!--商品列表区域-->
      <el-table :data="list" style="width: 100%" v-loading="loading" stripe size="middle" border height="700">
        <el-table-column label="序号" width="50" fixed align="center">
            <template slot-scope="scope">
                {{ (queryInfo.page - 1) * queryInfo.limit + scope.$index + 1 }}
            </template>
        </el-table-column>
        <el-table-column label="门店名称" prop="storename" width="200" show-overflow-tooltip fixed align="center"/>
        <el-table-column label="问题信息" prop="msg" show-overflow-tooltip align="center"/>
        <el-table-column label="上报时间" prop="createTimeStr" width="150" align="center"></el-table-column>
        <el-table-column label="处理时间" prop="updateTimeStr" width="150" align="center"></el-table-column>
        <el-table-column label="处理人" prop="updateBy" width="150" align="center"></el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.status == '0'">待处理</el-tag>
            <el-tag type="success" v-else>已处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="360" fixed="right" align="center">
          <!--作用域插槽-->
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="问题处理" placement="top">
              <el-button type="warning" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!--商品列表区域-->
      <!--分页区域-->
      <br>
      <div align="center">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="queryInfo.page" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.limit"
                       layout="total, sizes, prev, pager, next" :total="total">
        </el-pagination>
      </div>
      <!--分页区域-->
    </el-card>

    <el-dialog title="问题处理" :visible.sync="questionFlag" width="50%">
      <el-form ref="questionForm" :model="questionForm" label-width="110px">
        <el-form-item label="异常问题" prop="msg">
          {{questionForm.msg}}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitQuestionForm" v-loading="btnLoading">处 理</el-button>
        <el-button @click="questionFlag = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      btnLoading: false,
      questionFlag: false,
      total: 0,
      storelist: [],
      list: [],
      queryInfo: {
        page: 1,
        limit: 10,
        storeId: null,
        status: null
      },
      questionForm:{
        id: null,
        msg: null,
        topic: null,
        doorType: null,
        updateBy: null
      },
      username: null
    }
  },
  created() {
    this.username = window.sessionStorage.getItem('username')
    this.GetStore()

    this.getList()
    setInterval(() => {
      this.getList()
    }, 60000)
  },
  methods: {
    async getList() {
      this.loading = true
      const { data: res } = await this.$http.get("store-cls-question/list", { params: this.queryInfo });
      this.loading = false
      if (res.status == 0) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    async GetStore() {
      const { data: res } = await this.$http.get("store/");
      if (res.status == 0) {
        this.storelist = res.data;
      }
    },
    handleEdit(row) {
      this.questionForm.id = row.id;
      this.questionForm.msg = row.msg;
      this.questionForm.topic = row.topic;
      this.questionForm.doorType = row.doorType;
      this.questionForm.updateBy = this.username
      this.questionFlag = true
    },
    async submitQuestionForm() {
      this.btnLoading = true

      let command = 'B'
      if (this.questionForm.doorType == '1') {
        command = 'OUT-B'
      }
      const { data:res } = await this.$http.post('mqtt/operatorABDoor', {sn: "DahuaFace",command, topic: this.questionForm.topic})
      this.btnLoading = false
      if(res.status===0) {
        this.$confirm(`已发送门磁开启命令，当前门是否已经开启？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.$http.post('store-cls-question/update', this.questionForm).then(res => {
            if (res.data.status === 0) {
              this.questionFlag = false
              this.$message.success('处理成功')
              this.getList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }).catch(() => {
          // 用户取消操作
        })
      } else {
        this.$message.error('门禁指令发送失败');
      }
    },
    handleSizeChange(newSize){
      this.queryInfo.limit = newSize
      this.getList()
    },
    handleCurrentChange(newPage){
      this.queryInfo.page = newPage
      this.getList()
    },
  }
}
</script>

<style scoped>

</style>
